/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import IEnergyManagementProps from '../IEnergyManagementProps';
import { Grid } from '@scuf/common';
import './EnergyManagementSiteDashboardContent.scss';
import './EmaasSiteDashboardCommonTable.scss';
import EmaasEnergyUsageGraphKPIWidget from '../EmaasEnergyUsageGraphKPI/EmaasEnergyUsageGraphKPIWidget';
import { ApiContext } from '../../../context/ApiContext';
import { shouldComponentNotUpdateOnDateChange } from '../../shared/Utils/Utils';

const EMaaSEnergySiteDashboardGraphContent = React.memo(
  (props: IEnergyManagementProps) => {
    const { connectorConfig, requestContext, emaasContext } = props;

    return (
      <Grid className={`layout-grid`}>
        <Grid.Row className="layout-content-grid-row">
          <Grid.Column
            width={4}
            xsWidth={12}
            className="energyusage-kpi-card emaas-siteview-dashboard"
          >
            <EmaasEnergyUsageGraphKPIWidget
              connectorConfig={connectorConfig}
              requestContext={requestContext}
              emaasContext={emaasContext}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  },
  shouldComponentNotUpdateOnDateChange
);

export default EMaaSEnergySiteDashboardGraphContent;
